// extracted by mini-css-extract-plugin
export default {"grey400":"#bdbdbd","content":"Simple_content__CR0Pb"};